/**
 * Created by johnmc on 2019-01-21
 *
 * Details of leads
 */

export class LeadDetails {
    uid: number;
    created: string;
    first_name: string;
    second_name: string;
    email: string;
    email_hash: string;
    phone: string;
    fuel_type: string;
    eircode: string;
    county: string; 
    mprn: string;
    gprn: string; 
    ber_rating: string; 
    mail_sent: string;
    multi_zone: string;
    image: string;
  }
  